import React from "react";

export default function Step9() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          9
        </div>
        <h1 className="">
          Abra o aplicativo e coloque o seu e-mail e a senha que criou
          anteriormente. Em seguida, <b>clique em ENTRAR</b>.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3616.jpg?alt=media&token=204cc821-de6b-4cce-a93c-e20a1b3c8dd4"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
